/* eslint-disable */
import {
  getVehicles,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteVehicle,
} from '@/methods/vehicle';
import { ElNotification } from 'element-plus';
import { getDenyPrivilegeObject, getErrorMessage } from '@/compositions/helpers/helpers';

// Дедуп одновременных запросов списка: блок ЭТРН и постоянно смонтированные
// *FormDialog дергают getVehicles в один тик — схлопываем их в один HTTP-запрос.
// Ключ — partnerId (или 'all' без фильтра): фильтрованный и полный список
// не должны схлопываться в один запрос.
const vehiclesInFlight = new Map();

// Список в сторе один на всё приложение, а запросы с разным фильтром летят параллельно.
// Отвечают они в произвольном порядке, поэтому применяем только ответ на последний
// запрошенный фильтр — иначе полный список затирает отфильтрованный.
let vehiclesLatestKey = null;

const vehicleDetailsInFlight = new Map();

const state = {
  list: [],
  dataIsUpdated: false,
};

const getters = {
  getVehicles(state) {
    return state.list;
  },
};

const mutations = {
  UPSERT_VEHICLE(state, item) {
    state.list = [...state.list.filter((entry) => entry.id !== item.id), item];
  },
  UPDATE_VEHICLES(state, data) {
    state.list = data;
  },
  VEHICLES_DATA_IS_UPDATED(state, data) {
    state.dataIsUpdated = data;
  },
};

const actions = {
  getVehicle({ commit }, id) {
    if (vehicleDetailsInFlight.has(id)) return vehicleDetailsInFlight.get(id);
    const request = getVehicle(id).then((response) => {
      if (!response.data.success) throw new Error('Не удалось загрузить запись');
      commit('UPSERT_VEHICLE', response.data.data);
      return response.data.data;
    }).finally(() => vehicleDetailsInFlight.delete(id));
    vehicleDetailsInFlight.set(id, request);
    return request;
  },
  // payload.partnerId — партнёр брони: список сужается до его записей и «общих».
  getVehicles({ commit }, payload = {}) {
    const partnerId = Number(payload?.partnerId) || null;
    const key = partnerId ?? 'all';

    vehiclesLatestKey = key;

    if (vehiclesInFlight.has(key)) return vehiclesInFlight.get(key);

    const request = getVehicles(partnerId ? { partnerId } : {})
      .then((response) => {
        if (key !== vehiclesLatestKey) return;

        if ('success' in response.data && response.data.success) {
          commit('UPDATE_VEHICLES', response.data.data);
          commit('privilege/UPDATE_VEHICLE_PRIVILEGE', response.data.privilege, { root: true });
          commit('VEHICLES_DATA_IS_UPDATED', false);
        }
      })
      .catch(() => {
        if (key !== vehiclesLatestKey) return;

        commit('privilege/UPDATE_VEHICLE_PRIVILEGE', getDenyPrivilegeObject(), { root: true });
      })
      .finally(() => {
        vehiclesInFlight.delete(key);
      });

    vehiclesInFlight.set(key, request);

    return request;
  },

  createVehicle({ commit }, params) {
    return createVehicle(params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('VEHICLES_DATA_IS_UPDATED', true);

          return response.data.data?.id ?? null;
        }

        return null;
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });

        return null;
      });
  },

  updateVehicle({ commit }, { id, data }) {
    return updateVehicle(id, data)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('VEHICLES_DATA_IS_UPDATED', true);

          return id;
        }

        return null;
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });

        return null;
      });
  },

  deleteVehicle({ commit }, id) {
    deleteVehicle(id)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('VEHICLES_DATA_IS_UPDATED', true);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
